import {useRecoilState} from "recoil";
import {navbarInitialState, navbarState} from "./layoutAtom";

export const useNavbar = () => {
    const [navbar, setNavbar] = useRecoilState(navbarState)

    const setNavbarTitle = (title: string) => {
        setNavbar((prev) => ({...prev, pageTitle: title}))
    }

    const setNavbarBackButton = (hasBackButton: boolean) => {
        setNavbar((prev) => ({...prev, hasBackButton}))
    }

    const setNavbarSettingsButton = (hasSettingsButton: boolean) => {
        setNavbar((prev) => ({...prev, hasSettingsButton}))
    }

    const setNavbarBackgroundColor = (backgroundColor: string) => {
        setNavbar((prev) => ({...prev, backgroundColor}))
    }

    const reset = () => {
        setNavbar(navbarInitialState)
    }

    return {
        navbar,
        setNavbarTitle,
        setNavbarBackButton,
        setNavbarSettingsButton,
        setNavbarBackgroundColor,
        reset,
    }
}